import { createModalStore } from '@/shared/lib/modal';

export const useTrialPaywallExperimentModalStore = createModalStore();
